import { BarChart, DataUsage, Error, PieChart, QueryStats } from '@mui/icons-material';
import { Card, Grid } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import DetailedStatisticsCard from "examples/Cards/StatisticsCards/DetailedStatisticsCard";
import React, { useEffect, useState } from 'react'
import userStore from 'store/userStore';
import { CustomDescrypt } from 'global/func';
import { postDataWithResponse } from 'global/postFunc';
import { decodeToken } from 'react-jwt';
import StrukturAnggaranChartBar from 'examples/Charts/StrukturAnggaranChart/Bar';
import StrukturAnggaranChartPie from 'examples/Charts/StrukturAnggaranChart/Pie';
import ProgresRealisasiChartLine from 'examples/Charts/ProgresRealisasiChart/Line';
import ArgonAlert from 'components/ArgonAlert';


const Dashboard2 = () => {
    const { user, addReq, tahunAnggaran } = userStore(state => ({ user: state.user, addReq: state.addReq, tahunAnggaran: state.tahunAnggaran }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));
    const decodedUser = decodeToken(decryptedUser)

    const [dataAnggaran, setDataAnggaran] = useState([])
    const [dataStrukturAnggaran, setDataStrukturAnggaran] = useState({})
    const [dataRealisasiKeuangan, setDataRealisasiKeuangan] = useState({
        perbulan: [],
        progres: []
    })
    const [dataRealisasiFisik, setDataRealisasiFisik] = useState({
        perbulan: [],
        progres: []
    })
    const [statusLaporan, setStatusLaporan] = useState(0)

    const [loading, setLoading] = useState(false)

    const reqAnggaran = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/anggaran',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setDataAnggaran(res)
                setLoading(false)
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqAnggaran()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        reqChartStrukturBelanja()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqChartStrukturBelanja = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/chart-struktur-anggaran',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setDataStrukturAnggaran(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    useEffect(() => {
        reqChartRealisasiKeuanganPerBulan()
        reqChartRealisasiFisikPerBulan()
        reqStatusLaporanBulan()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const reqChartRealisasiKeuanganPerBulan = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/chart-realisasi-keuangan',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setDataRealisasiKeuangan(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    const reqChartRealisasiFisikPerBulan = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/chart-realisasi-fisik',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setDataRealisasiFisik(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    const reqStatusLaporanBulan = () => {
        addReq()
        setLoading(true)
        postDataWithResponse(
            '/admin-opd/status-laporan-bulanan',
            {
                kd_pd: decodedUser.kd_pd,
                ta: tahunAnggaran.ta
            },
            decryptedUser,
            (res) => {
                setStatusLaporan(res)
                setLoading(false)
                console.log(res);
            },
            (res) => {
                console.log(res)
                setLoading(false)
            }

        )
    }

    return (
        <ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Total Anggaran"
                            count={parseInt(dataAnggaran.total_anggaran).toLocaleString('id-ID')}
                            icon={{ color: "info", component: <DataUsage /> }}
                            percentage={{
                                color: "info",
                                count: '100%',
                                text: ""
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Target Realisasi Keuangan s/d Bulan Ini"
                            count={parseInt(dataAnggaran.target_keuangan).toLocaleString('id-ID')}
                            icon={{ color: "warning", component: <BarChart /> }}
                            percentage={{
                                color: "warning",
                                count: ((dataAnggaran.target_keuangan / dataAnggaran.total_anggaran) * 100).toFixed(2).replace('.', ',') + '%',
                                text: "Dari total Anggaran"
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Realisasi Keuangan s/d Bulan Ini"
                            count={parseInt(dataAnggaran.realisasi_keuangan).toLocaleString('id-ID')}
                            icon={{ color: "success", component: <PieChart /> }}
                            percentage={{
                                color: "success",
                                count: ((dataAnggaran.realisasi_keuangan / dataAnggaran.target_keuangan) * 100).toFixed(2).replace('.', ',') + '%',
                                text: "Dari Target"
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Deviasi Keuangan"
                            count={parseInt(dataAnggaran.target_keuangan - dataAnggaran.realisasi_keuangan).toLocaleString('id-ID')}
                            icon={{ color: "error", component: <QueryStats /> }}
                            percentage={{
                                color: "error",
                                count: (((dataAnggaran.target_keuangan - dataAnggaran.realisasi_keuangan) / dataAnggaran.target_keuangan) * 100).toFixed(2).replace('.', ',') + '%',
                                text: ""
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Anggaran Terinput"
                            count={parseInt(dataAnggaran.anggaran_terinput).toLocaleString('id-ID')}
                            icon={{
                                color: dataAnggaran.anggaran_terinput === dataAnggaran.total_anggaran ? 'info' : 'error',
                                component: <DataUsage />
                            }}
                            percentage={{
                                color: dataAnggaran.anggaran_terinput === dataAnggaran.total_anggaran ? 'info' : 'error',
                                count: ((dataAnggaran.anggaran_terinput / dataAnggaran.total_anggaran) * 100).toFixed(2).replace('.', ',') + '%',
                                text: "total Anggaran"
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Target Realisasi Fisik s/d Bulan Ini"
                            count={parseFloat(dataRealisasiFisik.target_sd_skrg).toFixed(2).replace('.', ',') + '%'}
                            icon={{ color: "warning", component: <BarChart /> }}
                        // percentage={{
                        //     color: 'info',
                        //     count: parseFloat(dataRealisasiFisik.target_sd_skrg).toFixed(2) + '%',
                        //     text: "total Target"
                        // }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Realisasi Fisik s/d Bulan Ini"
                            count={parseFloat(dataRealisasiFisik.realisasi_sd_skrg).toFixed(2).replace('.', ',') + '%'}
                            icon={{ color: "success", component: <PieChart /> }}
                        // percentage={{
                        //     color: "success",
                        //     count: ((dataRealisasiFisik.realisasi_sd_skrg / dataRealisasiFisik.target_sd_skrg) * 100).toFixed(2) + '%',
                        //     text: "Dari Target"
                        // }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={3}>
                        <DetailedStatisticsCard
                            title="Deviasi Fisik"
                            count={(dataRealisasiFisik.target_sd_skrg - dataRealisasiFisik.realisasi_sd_skrg).toFixed(2).replace('.', ',') + '%'}
                            icon={{ color: "error", component: <QueryStats /> }}
                        // percentage={{
                        //     color: "error",
                        //     count: (((dataRealisasiFisik.target_sd_skrg - dataRealisasiFisik.realisasi_sd_skrg) / dataRealisasiFisik.target_sd_skrg) * 100).toFixed(2) + '%',
                        //     text: ""
                        // }}
                        />
                    </Grid>
                </Grid>
            </ArgonBox>
            {
                dataAnggaran.anggaran_terinput !== dataAnggaran.total_anggaran  &&
                <ArgonBox my={3}>
                    <ArgonAlert color="error">
                        <Error fontSize="small" />&nbsp;
                        Input Perencanaan belum Tuntas
                    </ArgonAlert>
                </ArgonBox>
            }
            {
                parseInt(statusLaporan) > 0 &&
                <ArgonBox my={3}>
                    <ArgonAlert color="error">
                        <Error fontSize="small" />&nbsp;
                        {statusLaporan} Komponen Belanja belum Dilaporkan Bulan ini
                    </ArgonAlert>
                </ArgonBox>
            }
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={12} lg={8}>
                        <Card>
                            <StrukturAnggaranChartBar data={dataStrukturAnggaran} title='Grafik Struktur Anggaran' />
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={12} lg={4}>
                        <Card>
                            <StrukturAnggaranChartPie data={dataStrukturAnggaran} title='Grafik Struktur Anggaran' />
                        </Card>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={12} lg={6}>
                        <Card>
                            <ProgresRealisasiChartLine data={dataRealisasiKeuangan.perbulan} title='Realisasi Keuangan Per Bulan' />
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                        <Card>
                            <ProgresRealisasiChartLine data={dataRealisasiKeuangan.progres} title='Progres Realisasi Keuangan' />
                        </Card>
                    </Grid>
                </Grid>
            </ArgonBox>
            <ArgonBox my={3}>
                <Grid container spacing={3} mb={3}>
                    <Grid item xs={12} md={12} lg={6}>
                        <Card>
                            <ProgresRealisasiChartLine data={dataRealisasiFisik.perbulan} title='Realisasi Fisik Per Bulan' percent={true} />
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>
                        <Card>
                            <ProgresRealisasiChartLine data={dataRealisasiFisik.progres} title='Progres Realisasi Fisik' percent={true} />
                        </Card>
                    </Grid>
                </Grid>
            </ArgonBox>
        </ArgonBox>
    )
}

export default Dashboard2